import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kiosk.score');
import { OnDestroy, OnInit } from "@angular/core";
import { Service } from "src/libs/portal/season/service";
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'wiz-portal-kiosk-score',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kiosk.score/view.scss */
/* src/app/portal.kiosk.score/view.scss: no such file or directory */`],
})
export class PortalKioskScoreComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service)         public service: Service,@Inject( ActivatedRoute    )         private route: ActivatedRoute    ) { }

    public score = 0;
    public isImageGenerating = false;

    private readonly imageGenerationStatusKey = 'imageGenerationStatus';
    private readonly imageGenerationStatusEvent = 'imageGenerationStatusChanged';
    private readonly imageGenerationStatusHandler = (event: CustomEvent) => {
        this.isImageGenerating = event.detail === 'generating';
        this.service.render();
    };

    public async ngOnInit() {
        await this.service.init();
        this.route.queryParams.subscribe(params => {
            this.score = params['score'];
        });
        this.isImageGenerating = sessionStorage.getItem(this.imageGenerationStatusKey) === 'generating';
        window.addEventListener(this.imageGenerationStatusEvent, this.imageGenerationStatusHandler as EventListener);
        await this.service.render();
    }

    public ngOnDestroy() {
        window.removeEventListener(this.imageGenerationStatusEvent, this.imageGenerationStatusHandler as EventListener);
    }

}

export default PortalKioskScoreComponent;